import script from "./SeletorMultiplasImagens.vue?vue&type=script&setup=true&lang=js"
export * from "./SeletorMultiplasImagens.vue?vue&type=script&setup=true&lang=js"

import "./SeletorMultiplasImagens.vue?vue&type=style&index=0&id=14984371&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14984371"]])

export default __exports__